import { render } from "./ProfileStaff.vue?vue&type=template&id=cdec3bbe"
import script from "./ProfileStaff.vue?vue&type=script&lang=js"
export * from "./ProfileStaff.vue?vue&type=script&lang=js"
script.render = render

export default script